import React from 'react'
import BuscarIcon from "../assets/buscar.png"
import { useMainContext } from "../MainContext";

function Cabeza() {
    const { state, dispatch } = useMainContext();
    const filtro = state.filtros.paciente;

    const handleChange = (e) => {
        dispatch({ type: 'SET_FILTRO_PACIENTE', payload: e.target.value });
    };

    return (
        <div className="CabezaMain">
            <div className="Buscador">
                <div className="contenedor">
                    <div className="icono">
                        <img src={BuscarIcon} alt="I"/>
                    </div>
                    <div className="Continput">
                        <input type="text" placeholder="Buscar" onChange={handleChange} value={filtro} autoFocus/>
                    </div>
                </div>
            </div>
            <div className="Logo">
                <img src='./IMG/logoletras.svg'/>
            </div>
        </div>
    )
}

export default Cabeza
